// extracted by mini-css-extract-plugin
module.exports = {"fileUploadAnimation":"FileUploadAnimation_fileUploadAnimation__65VF1","blink":"FileUploadAnimation_blink__otPUx"};